var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container index-page"},[_c('v-head'),_vm._v(" "),_c('v-left',{attrs:{"current":"index"}}),_vm._v(" "),_c('div',[(_vm.loading)?_c('div',{staticClass:"my-loading"},[_c('i',{staticClass:"el-icon-loading"})]):_c('div',{staticClass:"count-dic"},[_c('div',[_vm._v("Welcome!")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a499e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/Index.vue
// module id = null
// module chunks = 